import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import dynamic from 'next/dynamic';
import useLazy from './use-lazy';
import Loading from '@/components/common/Indicator/Loading';
import { useRouter } from 'next/router';
import { CategoriesPropItem } from '@/api/item';

const CommonDrawerDynamic = dynamic(() => import('./comm-drawer'), { ssr: false, loading: Loading });

type CommonDrawer = {
  [key: string]: any;
  children?: React.ReactNode;
  customZIndex?: number;
  categoriesList?: CategoriesPropItem[];
};
export default forwardRef(function CommonDrawer(props: CommonDrawer, ref) {
  const { show, hide, visible, loaded, params } = useLazy();
  const router = useRouter();
  useImperativeHandle(ref, () => {
    return {
      show
    };
  });

  useEffect(() => {
    function handleRouteChange() {
      hide();
    }
    router.events.on('routeChangeComplete', handleRouteChange);
    return function cleanup() {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  if (!loaded) return null;

  return <CommonDrawerDynamic {...props} visible={visible} show={show} onCancel={hide} params={params} />;
});
